module.exports = __webpack_public_path__ + "img/cooling-banner.df4d9778.jpg";